<template>
    <div id="regitster">
        <div class="regitster_main  pubw">
            <!-- 表单一 -->
            <div class="form" v-show="curStep===0">
                <h2>免費註冊</h2>
                <el-form :model="emailForm" :rules="emailRuleForm" ref="emailForm">
                    <el-form-item  prop="email">
                        <el-input placeholder="電郵" v-model="emailForm.email"></el-input>
                      </el-form-item>
                </el-form>
                <el-form hide-required-asterisk :model="regitsterForm" :rules="regitsterRuleForm" ref="regitsterForm">
                    <el-form-item prop="verify">
                        <div class="code_input">
                             <el-input placeholder="验证码" v-model="regitsterForm.verify">
                          </el-input>
                          <SendCodeBtn :callback="sendCode" :emailForm="emailValid"/></SendCodeBtn>
                        </div>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input placeholder="密碼" type="password" v-model="regitsterForm.password"></el-input>
                      </el-form-item>
                </el-form>
                <optionsButton class="regitsterNow" title="註冊" :callback="regitster" icon="el-icon-right"/>
                <p class="statement">當你按下註冊鍵時，表示你接受Goods 2 Go的<span>使用條款</span>及<span>隱私政策</span></p>
                <div class="regitster">已經註冊？<span @click="login">請登入</span></div>
            </div>
            <!-- 表单二 -->
            <div class="form" v-show="curStep===1">
                <h2>聯絡方法</h2>
                <p class="tips">如寄件有問題，我們會即時聯絡你。</p>
                <el-form hide-required-asterisk :model="regitsterForm2" :rules="regitsterRuleForm2" ref="regitsterForm2">
                    <el-form-item prop="name">
                      <el-input placeholder="姓名" v-model="regitsterForm2.name"></el-input>
                    </el-form-item>
                    <el-form-item style="margin-bottom: 8px;" prop="userType">
                        <el-radio-group v-model="regitsterForm2.userType">
                          <el-radio label="0">個人</el-radio>
                          <el-radio label="1">公司</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div class="phoneNumberForm">
                        <!-- 选择电话框 -->
                        <el-select class="selectPhoneAttr" v-model="regitsterForm2.QCcellCore" placeholder="号码归属地">
                            <el-option
                            v-for="item in QCcellCoreList"
                            :key="item.id"
                            :label="item.area"
                            :value="item.area">
                          </el-option>
                        </el-select>
                        <el-form-item class="phoneNumberInput" prop="phoneNumber">
                            <el-input placeholder="手機號碼" v-model="regitsterForm2.phoneNumber"></el-input>
                        </el-form-item>
                    </div>
                    <el-form-item prop="agree" class="agrees" style="margin-bottom: 0px;">
                        <el-checkbox-group v-model="regitsterForm2.agree">
                          <el-checkbox label="0" name="findPartner">我也在尋找倉儲合作夥伴。</el-checkbox>
                          <el-checkbox label="1" name="agreeSMS">我同意Goods 2 Go使用我的聯絡電話以SMS形式傳送通知。</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </el-form>
               <div class="btm">
                    <div class="back" @click="goback">返回</div>
                    <optionsButton class="regitsterNow" title="确定" :callback="regitster" style="margin-bottom: 0px;" icon="el-icon-right"/>
               </div>
            </div>
        </div>
    </div>
</template>

<script>
  // 引入组件
  import optionsButton from '@/components/optionButton'
  import SendCodeBtn from '@/components/SendCodeBtn'
  import { Loading } from 'element-ui';
export default {
    name:'regitster',
    components:{
        optionsButton,
        SendCodeBtn
    },
    data(){
        // 验证邮箱正则
            let checkEamil = (rule,value,callback)=>{
            // const regEmail=/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/;
            // 自定义正则
            // const regEmail = /^[A-Za-z0-9]+@+[A-Za-z0-9*]+[\.]+[A-Za-z0-9]*$/
            const regEmail = /^[A-Za-z0-9/.]+@+[A-Za-z0-9*]+[/.A-Za-z0-9]*$/
            if(!regEmail.test(value)) return callback(new Error('請輸入正確的電郵格式!'))
            return callback()
        }

        // 验证电话正则
        let checkMobile = (rule,value,callback)=>{
            const regMobile= /^\d{8}|\d{11}$/
            // const  regMobile = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
            if(!regMobile.test(value)) return callback(new Error('請輸入正確的電話格式!'))
            return callback()
        }
        return {
            // 当前注册的步骤
            curStep:0,
            // 登录表单信息
            regitsterForm:{
                password:'',
                verify:'',
            },
            // 邮箱表单
            emailForm:{
                email:''
            },
            // 邮箱表单规则
            emailRuleForm:{
                email:[
                    { required: true, message: '* 請輸入有效的電子郵件地址。', trigger: 'blur' },
                    {validator:checkEamil,trigger:'blur'}    
                 ]
            },
            // 登录表单规则
            regitsterRuleForm:{
                password:[
                { required: true, message: '* 請填寫密碼。', trigger: 'blur' },
                ],
                verify:[
                { required: true, message: '* 請填寫验证码。', trigger: 'blur' },
                ]
            },
            // 登录表单信息2
            regitsterForm2:{
                name:'',
                phoneNumber:'',
                userType:'0',
                QCcellCore:'+852',
                agree:[]
            },
            // 登录表单规则
            regitsterRuleForm2:{
                mail:[
                   { required: true, message: '* 請輸入您的姓名', trigger: 'blur' },
                ],
                phoneNumber:[
                    { required: true, message: '* 請正確填寫聯絡電話', trigger: 'blur' },
                    {validator:checkMobile,trigger:'blur'}
                 ],
                agree:[
                    { required: true, message: '* 請勾選同意協定', trigger: 'blur' },
                ],
                userType:[
                    { required: true, message: '* 請選擇用戶類型', trigger: 'blur' },
                ]
            },
             // 归属地列表
            QCcellCoreList:[
                {
                    id:0,
                    attr:852,
                    icon:'el-icon-s-check'
                },
                {
                    id:1,
                    attr:853,
                    icon:'el-icon-s-check'
                },
                
            ]
        }
    },
    created() {
        this.getQCcellCore()
    },
    methods: {
        // 获取号码归属地列表
        async getQCcellCore(){
            let res = await this.$http.get('app/data/getCurrency')
            this.QCcellCoreList = res.data.data
        },
        // 监听用户点击注册按钮
        async regitster(){
            
            if(this.curStep == 0){
                this.$refs.regitsterForm.validate(async valid=>{
                    if(!valid) return
                    this.curStep = 1
                        // 获取号码归属里列表
                        this.getQCcellCore()
                    return
                })
                return
            }
            if(this.curStep == 1){
                this.$refs.regitsterForm2.validate(async valid=>{
                    if(!valid) return
                    let userObj = {...this.regitsterForm,...this.regitsterForm2,...this.emailForm}
                    // 发送请求
                    let res = await this.$http.post(`/app/login/register?userType=${userObj.userType}&email=${userObj.email}&verify=${userObj.verify}&password=${userObj.password}`)
                    console.log(res)
                    if(!res.data.code) return this.$message.error(res.data.message)
                    if(res.data.success) return this.$message.success('注册成功!')
                })
            }
        },
        // 监听用户点击登录按钮
        login(){
            this.$router.push('/login')
        },
        // 监听用户点击返回
        goback(){
            this.curStep = 0
        },
        // 监听号码归属地改变
        chagnePhoneAttr(value){
            this.regitsterForm2.attribution = value
        },
        // 监听用户点击发送验证码
        async sendCode(){
            let email = this.emailForm.email
            let loadingInstance = Loading.service();
            let res = await this.$http.post(`app/login/registerEmail?email=${email}`)
            console.log(res)
            if(!res.data.success){
                loadingInstance.close();
                this.$message.error(res.data.message)
                return false  
            }
            if(res.data.success){
                loadingInstance.close();
                this.$message.success("發送成功")
            }
            return true
        },
        // 判断是否可以发送验证码
        emailValid(){
            return this.$refs.emailForm
        }
    },
}
</script>

<style lang="less"> 
    #regitster{
        background-color: #f4f4f4;
        .regitster_main{
            display: flex;
            height: 698.18px;
            align-items: center;
            margin:0 auto;
            .form{
                .tips{
                    margin-bottom: 10px;
                    font-size:15px;
                }
                .phoneNumberForm{
                    width: 390px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 20px;
                    .selectPhoneAttr{
                        width: 130px;
                        .el-input__inner{
                            width: inherit;
                        }
                    }
                    .phoneNumberInput{
                        width: 200px;
                        margin-bottom:0;
                        .el-input__inner{
                            width: 100%;
                        }
                    }
                }
                .code_input{
                    width: 390px;
                    display: flex;
                    justify-content: space-between;
                    .el-input__inner{
                        border-color: #c0c4cc;
                        width: 80%;
                        margin-right:0px;
                    }
                    .el-input-group__append{
                        border: 1px solid #DCDFE6;
                    }
                    button{
                        width: 20%;
                        text-align: center;
                    }
                }
                .btm{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .regitsterNow{
                        width: 70%;
                    }
                    .back{
                        font-size: 18px;
                    }
                    .back:hover{
                        cursor: pointer;
                        opacity: .6;
                    }
                }
                h2{
                    font-size: 30px;
                    margin-bottom:50px;
                    font-weight:550;
                }
                .agrees{
                    width: 390px;
                }
                .statement{
                    margin: 20px 0;
                    span{
                        border-bottom:2px solid @colorMain;
                        padding-bottom:3    px;
                    }
                }
                .regitsterNow{
                    width: 390px;
                    margin: 15px 0;
                }
                .regitster{
                    font-size: 18px;
                    margin-top: 35px;
                    span{
                        border-bottom:2px solid @colorMain;
                        padding-bottom:5px;
                        color:@colorMain;
                    }
                }
                .regitster:hover{
                    cursor: pointer;
                }
                .statement{
                    font-size: 13px;
                    span{
                        color: @colorMain;
                        margin:0 6px;
                    }
                    span:hover{
                        cursor: pointer;
                    }
                }
                .el-input__inner{
                    width: 390px;
                    height: 56px;
                    border-radius: 12px;
                }
                .el-input__inner:focus{
                    border-color: @colorMain !important;
                }
                .forget{
                    color: #A7A7A7;
                    font-size: 13px;
                    margin:15px 0 30px  ;
                }
                .forget:hover{
                    cursor: pointer;
                }
                .selectPhoneAttr{
                    text-align: center;
                    width: 30%;
                    height: 56px;
                    border-radius: 10px;
                    background-color: #fff;
                    line-height: 56px;
                    box-shadow: 0px 2px 5px #ccc;
                    span{
                        -webkit-user-select: none; /* Chrome all / Safari all */
                        -moz-user-select: none; /* Firefox all */
                        -ms-user-select: none; /* IE 10+ *//* No support for these yet, use at own risk */
                        -o-user-select: none;
                        user-select: none;
                    }
                }
                .selectPhoneAttr>span{
                    display: inline-block;
                    width: 100%;
                    height: 100%;
                    span{
                        font-size: 20px;
                        margin:0 3px;
                    }
                }
                .selectPhoneAttr>span:hover{
                    cursor: pointer;
                }
            }
        }
    }
</style>